import React, { useState, useRef } from 'react';
import {
        Check,
        Star,
        Shield,
        Lock,
        Play,
        Pause,
        BookOpen,
        Users,
        Globe,
        Sunrise,
        Compass,
        Waves,
        HeartPulse,
        Sparkles,
        TrendingUp,
        Zap,
        XCircle,
        Headphones,
        ChevronDown,
        ChevronUp,
        BookHeadphones
} from 'lucide-react';
import { Button } from '../components/ui/Button';
import { AudioPlayer } from '../components/AudioPlayer';
import { Users, Globe } from 'lucide-react';

interface LandingPageProps {
  lang: 'es' | 'en';
}

export function LandingPage({ lang }: LandingPageProps) {
  const content = {
    es: {
      badge: 'Nuevo Manual de Consciencia',
      headline: '¿Quieres Despertar de la Matrix Sin Perderte a Ti Mismo?',
      subheadline: 'Nuevo Libro Transformador de Consciencia Revela 7 Códigos Ocultos Para Recordar Quién Eres Realmente Y Jugar El Verdadero Juego de la Vida, Comenzando Hoy',
      lead: 'Despierta a tu verdadero poder en los próximos 90 minutos usando este manual espiritual decodificado de la sabiduría antigua y la ciencia de la simulación... incluso si todavía te sientes atrapado en el miedo, la confusión o ciclos interminables de auto-mejora.',
      ctaRed: 'SÍ — ESTOY LISTO PARA JUGAR',
      ctaGold: 'ESTOY LISTO PARA RECORDAR',
      quote: 'Hay dos tipos de humanos: Los que pasan toda su vida reaccionando al tablero... y los que se dan cuenta de que son ellos quienes sostienen el control. ¿Cuál eres tú?',
      credibility: [
        'Confiado Por Lectores Despertando En Más de 25 Países',
        'Destacado en círculos espirituales explorando consciencia, DMT, energía y el fenómeno Matrix'
      ],
      painTitle: 'Si eres como la mayoría de los buscadores, estás cansado de sentir que falta algo.',
      painSubtitle: 'Como si nacieras para más, pero no puedes recordar qué. En este momento, probablemente estés:',
      painPoints: [
        'Persiguiendo el éxito pero sintiéndote vacío por dentro',
        "Viendo a otros 'manifestar' mientras luchas con el caos",
        "Abrumado por consejos de 'sanación' que nunca funcionan",
        'Preguntándote por qué los mismos patrones se repiten',
        'Frustrado porque sabes que la realidad es más profunda'
      ],
      urgencyTitle: 'Estamos viviendo la mayor ventana de despertar en la historia humana.',
      urgencyText: "Cada día que sigues ejecutando el viejo programa, pierdes tiempo, energía y la oportunidad de recordar por qué viniste aquí. El sistema se alimenta de tu distracción mientras tu alma susurra: 'Despierta... tú eres el jugador.'",
      authorTitle: 'De: Gabriel Beltrán | Tierra, Densidad Nivel 3',
      authorStory: 'Una vez viví dormido dentro del sistema, trabajando, logrando, repitiendo los mismos patrones. Entonces todo se quebró. Me di cuenta de que mi vida no era aleatoria — estaba programada. Años de investigación y encuentros con el DMT descubrieron la arquitectura oculta de la realidad. Ese viaje se convirtió en ¿Estás Listo Para Jugar?',
      offerTitle: 'Edición Digital',
      priceOld: '$57',
      priceNew: '$27',
      offerFeatures: [
        'Acceso digital instantáneo',
        'Lee en cualquier dispositivo',
        'Audiolibro completo (1:49:47)'
      ],
      bonusTitle: 'BONO GRATIS — DMT: La Molécula Espiritual',
      bonusDesc: 'Audiolibro + Libro Digital ($39.97 Valor). Descubre la molécula que une ciencia y espíritu. 92 páginas | Espiritualidad, Consciencia, Ciencia',
      packTitle: 'Pack Despertar — BEST SELLER',
      packPriceOld: '$96.94',
      packPriceNew: '$27',
      packFeatures: [
        '¿Estás listo para jugar? (audio + eBook) — $27',
        'Meditaciones Guiadas 30 días (audio binaural) — $57',
        'BONUS: DMT La Molécula de Dios (audio + eBook) — $27',
        'Masterclass: "El Verdadero Secreto de los Élites" (1hr)'
      ],
      modulesTitle: 'QUÉ OBTIENES: El Sistema Central ($57 Valor)',
      modules: ['El Velo Revelado', 'Las Reglas Ocultas Del Sistema', 'La Secuencia del Despertar', 'El Plan del Juego Infinito'],
      guaranteeTitle: 'Garantía "Recuerda Quién Eres" — 7 Días',
      guaranteeText: 'Si este libro no despierta un cambio genuino en tu consciencia dentro de 7 días, reembolso completo en 24 horas. Sin preguntas.',
      finalUrgency: 'Oferta Por Tiempo Limitado. Una vez agotada esta primera tirada, el precio vuelve a $47. La consciencia se está acelerando — el próximo ciclo no esperará.',
      path1: 'Camino 1: Seguir jugando ciego, repitiendo ciclos.',
      path2: 'Camino 2: Despertar y jugar conscientemente.',
      faq: [
        {
          q: '¿Es otro libro de "Ley de Atracción"?',
          a: 'No. No te pide visualizar ni afirmar. Te da la arquitectura de cómo funciona la realidad — y por qué tu mente ya sabía esto antes de que te lo enseñaran.'
        },
        {
          q: '¿Tengo que creer en el DMT o las drogas?',
          a: 'El DMT se usa como lente científica, no como prescripción. Nunca se sugiere su consumo. Es una herramienta de comprensión.'
        },
        {
          q: '¿Por qué solo $27 si es tan poderoso?',
          a: 'Porque el objetivo no es ganar dinero con tu confusión — es que lo leas. Un libro de $200 que no se abre no ayuda a nadie.'
        },
        {
          q: '¿Cuánto tiempo necesito?',
          a: '90 minutos para leerlo. 7 días con el Reinicio Mental para sentirlo. Una vida para jugarlo.'
        },
        {
          q: '¿Y si no funciona para mí?',
          a: 'Garantía de 30 días. Pero si lees los primeros 3 capítulos y no sientes el cambio — probablemente aún no estabas listo. Y eso también está bien.'
        },
        {
          q: '¿En qué idioma está?',
          a: '¿Estás Listo Para Jugar? está en español. Mental Reset 7D está disponible en inglés y español.'
        },
      ],

      ps: 'P.D.: Tu despertar no comienza cuando terminas el libro. Comienza en el momento en que dices que sí.'
    },
    en: {
      badge: 'New Consciousness Manual - Digital Edition',
      headline: 'Do You Want to Wake Up from the Matrix Without Losing Yourself?',
      subheadline: 'New Transformational Consciousness Book Reveals 7 Hidden Codes to Remember Who You Really Are And Play The True Game of Life, Starting Today',
      lead: 'Awaken to your true power in the next 90 minutes using this spiritual manual decoded from ancient wisdom and simulation science... even if you still feel trapped in fear, confusion, or endless self-improvement cycles.',
      ctaRed: 'YES — I AM READY TO PLAY',
      ctaGold: 'YES — I AM READY TO PLAY',
      quote: 'There are two types of people: those who play as a Piece, and those who hold the Controller. Which are you?',
      credibility: [
        'Read by Awakening Souls in Over 25+ Countries',
        'Circulating in consciousness communities exploring DMT, quantum reality, simulation theory, and spiritual awakening'
      ],
      painTitle: 'If you´ve done everything right — meditated, healed, read all the books — and still feel like something is missing...',
      painSubtitle: "You were right. Something IS missing. Not from your life — from your understanding of the game. you are probably:",
      painPoints: [
        'Chasing success but feeling empty inside',
        "Watching others 'manifest' while you struggle with chaos",
        "Drowning in healing advice that adds knowledge but removes nothing",
        'Wondering why the same patterns keep repeating',
        'Sensing that reality is deeper — but unable to access it'

      ],
      urgencyTitle: 'We are inside the most significant awakening window in recorded history.',
      urgencyText: "Every day you run the old program — the same fear loops, the same confusion, the same patterns — you're not failing. You're just playing without knowing the rules. The system was designed to keep you that way. Your soul wasn't.",
      authorTitle: 'From: Gabriel Beltrán | Earth, Density Level 3',
      authorStory: "I once lived asleep within the system, working, achieving, repeating the same patterns. Then everything cracked. I realized my life wasn't random — it was programmed. Years of research and encounters with DMT uncovered the hidden architecture of reality. That journey became Are You Ready To Play?",
      offerTitle: 'Digital Edition',
      priceOld: '$57',
      priceNew: '$27',
      offerFeatures: [
        'Instant digital access',
        'Read on any device',
        'Full audiobook (1:49:47)'
      ],
      bonusTitle: 'FREE BONUS — DMT: The Spirit Molecule',
      bonusDesc: 'Audiobook + Digital Book ($39.97 Value). Discover the molecule that bridges science and spirit. 92 pages | Spirituality, Consciousness, Science',
      packTitle: 'Awakening Pack — BEST SELLER',
      packPriceOld: '$96.94',
      packPriceNew: '$27',
      packFeatures: [
        'Are You Ready To Play? (audio + eBook) — $27',
        '30 Days Guided Meditations (binaural audio) — $57',
        'BONUS: DMT The God Molecule (audio + eBook) — $27',
        'Masterclass: "The True Secret of the Elites" (1hr)'
      ],
      modulesTitle: 'WHAT YOU GET: The Central System ($57 Value)',
      modules: ['The Veil Revealed', 'The Hidden Rules Of The System', 'The Awakening Sequence', 'The Infinite Game Plan'],
      guaranteeTitle: '"Remember Who You Are" Guarantee — 7 Days',
      guaranteeText: "If this book doesn't spark a genuine shift in your consciousness within 7 days, you'll receive full refund within 24. No questions asked.",
      finalUrgency: "Limited Time Offer. Once this first run is sold out, the price returns to $47. Consciousness is accelerating — the next cycle won't wait.",
      path1: 'Path 1: Keep playing blind, repeating cycles.',
      path2: 'Path 2: Wake up and play consciously.',
      faq: [
        {
          q: "Isn't this just another Law of Attraction book?",
          a: "No. This doesn't ask you to visualize or repeat affirmations. It gives you the architecture of how reality actually works — and why your mind already knew this before anyone taught you otherwise."
        },
        {
          q: "Do I need to believe in DMT or drugs?",
          a: "DMT is used as a scientific lens — not a prescription. Its use is never suggested. It's a tool for understanding, not consumption."
        },
        {
          q: "Why only $27 if this is so powerful?",
          a: "Because the goal isn't to profit from your confusion — it's to get you reading. A $200 book that never gets opened helps no one."
        },
        {
          q: "How much time do I need?",
          a: "90 minutes to read it. 7 days with Mental Reset to feel it. A lifetime to play it."
        },
        {
          q: "What if it doesn't work for me?",
          a: "7-day guarantee. But honestly — if you read the first 3 chapters and feel nothing, you probably weren't ready yet. And that's okay too."
        },
        {
          q: "What language is it in?",
          a: "All the materials, Ebooks, AudioBooks and practice manual, Are You Ready To Play?, DMT: Spirit Molecule and Mental Reset 7D, are available in English."
        },
      ],

      ps: "P.S.: Your awakening doesn't begin when you finish the book. It begins the moment you say yes."
    }
  };

  const t = content[lang];
  // Assets URLs
  const AUDIO_DMT = "https://res.cloudinary.com/dab9nhevk/video/upload/v1772470476/reseñaDMTingles_g7utk6.mp3";
  const [dmtPlaying, setDmtPlaying] = useState(false);
  const [dmtTime, setDmtTime] = useState(0);
  const [dmtDuration, setDmtDuration] = useState(0);
  const dmtRef = useRef<HTMLAudioElement>(null);

  // Optimizadas: calidad auto, formato webp, ancho máximo controlado
const IMG_PORTADADMT = "https://res.cloudinary.com/dab9nhevk/image/upload/v1772471980/Generated_Image_bonomoleculaDMT_g0q9nc.png";
const IMG_MOCKUP = "https://res.cloudinary.com/dab9nhevk/image/upload/q_auto,f_auto,w_600/v1772470975/Generated_Image_R_U_ready_to_play_mockup_zteork.png";

const [dmtExpanded, setDmtExpanded] = useState(false);
const [mentalExpanded, setMentalExpanded] = useState(false);
const IMG_MENTAL_RESET = ""; // ← pega aquí la URL cuando la tengas
const [openFaq, setOpenFaq] = useState<number | null>(null);
const [showTerms, setShowTerms] = useState(false);
const [showPrivacy, setShowPrivacy] = useState(false);
const [showDisclaimer, setShowDisclaimer] = useState(false);


return (
  <>
  <div className="relative z-10 w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8  pt-0 pb-2 sm:pt-1 sm:pb-4 space-y-16 sm:space-y-24">

    {/* 1. Hero Section */}
    <section className="text-center space-y-3 sm:space-y-4 min-h-[85vh] flex flex-col justify-center pt-0">
    <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-transparent rounded-2xl -z-10 pointer-events-none" />  
      <div className="flex justify-center w-full">
        <div className="bg-matrix/10 border border-matrix text-matrix px-20 py-0.5 rounded-full font-mono uppercase w-fit whitespace-nowrap"
          style={{fontSize: 'clamp(0.5rem, 2vw, 0.75rem)'}}>
          {t.badge}
        </div>
      </div>

      {/* HEADLINE — controlado en desktop */}
      <h1 className="text-3xl sm:text-4xl lg:text-4xl xl:text-5xl font-serif font-bold leading-tight tracking-tight px-2 max-w-4xl mx-auto"
        style={{textShadow: '0 2px 10px rgba(0,0,0,1), 0 0 30px rgba(0,0,0,0.9)'}}>
        <span className="text-white">
          Want to{' '}
        </span>
        <span className="text-glow-matrix animate-pulse">
          Wake Up {' '}
        </span>
        <span className="text-white">
          from the Matrix{' '}
        </span>
        <span className="text-glow-matrix animate-pulse">
          Without Losing Yourself?
        </span>
      </h1>

      {/* SUBHEADLINE — más compacta */}
      <h2 className="text-sm sm:text-base md:text-lg text-gray-300 font-serif max-w-2xl mx-auto leading-relaxed border-l-4 border-gold pl-4 italic text-left">
        {t.subheadline}
      </h2>

      {/* LEAD — más corto visualmente */}
      <p className="text-sm sm:text-base text-gray-300 max-w-xl mx-auto leading-snug px-2 bg-black/30 rounded-lg py-2">
        {t.lead}
      </p>

      {/* AUDIO + CTA visibles en primer fold */}
      <div className="py-1 sm:py-2">
        <AudioPlayer />
      </div>

    {/* BOTÓN PÍLDORA — Piece vs Player */}
    <div className="flex flex-col items-center gap-3">
      {/* Texto encima */}
      <p className="text-xs sm:text-sm text-gray-400 uppercase tracking-widest font-mono">
        Right now, you are playing as one of these:
      </p>

      {/* GLOW animado alrededor del botón */}
      <div className="relative w-full sm:w-auto">


        {/* Anillo pulsante verde */}
        <div className="absolute -inset-1 rounded-full animate-pulse blur-sm pointer-events-none"
          style={{background: 'linear-gradient(to right, rgba(220,38,38,0.5), rgba(37,99,235,0.5))'}} />
        <div className="absolute -inset-2 rounded-full animate-ping opacity-30 pointer-events-none"
          style={{background: 'linear-gradient(to right, rgba(220,38,38,0.3), rgba(37,99,235,0.3))'}} />
        

        {/* PÍLDORA */}
        <div className="flex items-stretch rounded-full overflow-hidden border-2 border-white/20 shadow-2xl w-full sm:w-auto">
          
          {/* Lado izquierdo — PIECE (rojo) */}
          <button
            onClick={() => document.getElementById('pain-section')
              ?.scrollIntoView({ behavior: 'smooth' })}
            className="flex-1 sm:flex-none px-6 sm:px-10 py-3 sm:py-4 bg-red-600 hover:bg-red-500 text-white font-bold uppercase tracking-wider transition-all duration-300 hover:shadow-[0_0_30px_rgba(220,38,38,0.7)] flex flex-col items-center justify-center gap-0.5"
            style={{textShadow: '0 2px 4px rgba(0,0,0,0.5)'}}
          >
            <div className="flex items-center gap-2 text-base sm:text-xl">
              <span className="text-red-200 text-sm">🔴</span>
              PIECE
            </div>
            <span className="text-red-200/70 text-xs font-normal tracking-normal">
              keep reading
            </span>
          </button>

          {/* Divisor central */}
          <div className="flex items-center justify-center bg-black/80 px-3 py-4 border-x border-white/10">
            <span className="text-gray-400 text-xs font-mono">or</span>
          </div>

        {/* Lado derecho — PLAYER (azul) */}
        <button
          onClick={() => document.getElementById('offer-section')
            ?.scrollIntoView({ behavior: 'smooth' })}
          className="flex-1 sm:flex-none px-6 sm:px-10 py-3 sm:py-4 bg-blue-600 hover:bg-blue-500 text-white font-bold uppercase tracking-wider transition-all duration-300 hover:shadow-[0_0_30px_rgba(37,99,235,0.7)] flex flex-col items-center justify-center gap-0.5"
          style={{textShadow: '0 2px 4px rgba(0,0,0,0.5)'}}
        >
          <div className="flex items-center gap-2 text-base sm:text-xl">
            PLAYER
            <span className="text-blue-200 text-sm">🔵</span>
          </div>
          <span className="text-blue-200/70 text-xs font-normal tracking-normal">
            I Need the Controller
          </span>
        </button>
      </div>
    </div>
    <div className="flex items-center gap-2 text-xs text-gray-400">
      <Lock size={12} />
      <span>One path keeps you reacting. The other gives you the controller. Choose Wisely.</span>
    </div>    

  </div>

    
    </section>

      {/* 2. Quote Hook */}
        <section className="relative py-10 sm:py-10">

          {/* Fondo MUY transparente para ver imagen */}
          <div className="absolute inset-0 bg-black/20 backdrop-blur-[2px] rounded-2xl" />

          <div className="relative z-10 px-6 sm:px-10">

            {/* Texto principal */}
            <blockquote className="text-xl sm:text-2xl md:text-3xl font-serif text-center italic leading-relaxed max-w-3xl mx-auto mb-10"
              style={{textShadow: '0 2px 8px rgba(0,0,0,1), 0 0 20px rgba(0,0,0,0.9)'}}>
              <span className="text-white">
                Every person alive is playing this game.{' '}
              </span>
              <span className="text-red-400">
                Most don't know it,{' '}
              </span>
              <span className="text-blue-400">
                The ones who do — play differently.{' '}
              </span>
              {/*<span className="text-blue-400">
              //  holding the controller.{' '}
              //</span>*/}
              <span className="text-yellow-400 font-bold">
                Which one are you becoming?
              </span>
            </blockquote>

            {/* DOS TIPOS — con iconos */}
            <div className="grid grid-cols-2 gap-4 sm:gap-8 max-w-2xl mx-auto">

              {/* PIECE card — narrativo */}
              <div className="flex flex-col items-center gap-3 p-4 sm:p-6 rounded-xl border border-red-500/40 bg-red-950/20 backdrop-blur-sm hover:bg-red-950/40 transition-all">
                <div className="text-3xl sm:text-4xl">♟️</div>
                <div className="text-red-400 font-bold text-sm sm:text-lg uppercase tracking-widest">
                  The Piece
                </div>
                <p className="text-gray-300 text-xs sm:text-sm text-center leading-relaxed"
                  style={{textShadow: '0 1px 4px rgba(0,0,0,1)'}}>
                  Follows rules they never chose.<br/>
                  Reacts to a board they can't see.<br/>
                  Waits for life to move them. <br/>
                  <br/>
                </p>
                <div className="px-3 py-1 rounded-full bg-red-600/20 border border-red-500/30 text-red-400 text-xs text-center font-mono">
                  😴...  Running the old program
                </div>
                {/* CTA narrativo — sigue leyendo */}
                <button
                  onClick={() => document.getElementById('pain-section')
                    ?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-xs text-gray-500 hover:text-red-400 underline mt-1 transition-colors"
                >
                  Still don't know?... keep reading →
                </button>
              </div>

              {/* PLAYER card — compra */}
              <div className="relative flex flex-col items-center gap-3 p-4 sm:p-6 rounded-xl border border-blue-500/40 bg-blue-950/20 backdrop-blur-sm hover:bg-blue-950/40 transition-all">
                
                {/* Badge recomendado */}
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-600 text-white text-xs px-3 py-0.5 rounded-full font-bold uppercase whitespace-nowrap">
                  ✨ This could be you
                </div>

                <div className="text-3xl sm:text-4xl">🎮</div>
                <div className="text-blue-400 font-bold text-sm sm:text-lg uppercase tracking-widest">
                  The Player
                </div>
                <p className="text-gray-300 text-xs sm:text-sm text-center leading-relaxed"
                  style={{textShadow: '0 1px 4px rgba(0,0,0,1)'}}>
                  Sees the hidden rules.<br/>
                  Holds the controller.<br/>
                  Moves with intention — not reaction..
                </p>
                <div className="px-3 py-1 rounded-full bg-blue-600/20 border border-blue-500/30 text-blue-400 text-xs text-center font-mono">
                  👁️ Conscious. In the game.
                </div>
                {/* CTA de compra */}
                <button
                  onClick={() => document.getElementById('offer-section')
                    ?.scrollIntoView({ behavior: 'smooth' })}
                  className="mt-1 w-full py-2 px-4 bg-blue-600 hover:bg-blue-500 text-white text-xs font-bold rounded-lg uppercase tracking-wide transition-all shadow-[0_0_15px_rgba(37,99,235,0.5)]"
                >
                  I AM THE PLAYER →
                </button>
              </div>

            </div>

          </div>    
      </section>

      {/* 3. Credibility */}
      <section className="flex flex-col gap-4 text-xs sm:text-sm md:text-base text-gray-400 border border-matrix/20 p-4 sm:p-6 rounded-lg bg-black/80">
        <div className="flex items-center gap-3">
          <div className="shrink-0 w-8 h-8 rounded-full bg-matrix/10 border border-matrix/30 flex items-center justify-center text-matrix">
            <Users size={16} />
          </div>
          <span className="leading-relaxed">{t.credibility[0]}</span>
        </div>

        <div className="flex items-center gap-3">
          <div className="shrink-0 w-8 h-8 rounded-full bg-matrix/10 border border-matrix/30 flex items-center justify-center text-matrix">
            <Globe size={16} />
          </div>
          <span className="leading-relaxed">{t.credibility[1]}</span>
        </div>

      </section>

      {/* 4. Pain Points */}
      
      <section id="pain-section" className="space-y-6 bg-gray-900/50 p-5 sm:p-8 rounded-xl border border-red-900/30">
        <div className="text-center space-y-3">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-serif text-white leading-snug">
            {t.painTitle}
          </h3>
          <p className="text-sm sm:text-base text-gray-400">{t.painSubtitle}</p>
        </div>
        <ul className="space-y-3 max-w-2xl mx-auto">
          {t.painPoints.map((point, i) =>
            <li key={i} className="flex items-start gap-3 text-gray-300">
              <XCircle size={18} className="text-red-500 mt-1 shrink-0" />
              <span className="text-sm sm:text-lg leading-relaxed">{point}</span>
            </li>
          )}
        </ul>
      </section>

      {/* 5. Urgency — expandida */}
      <section className="space-y-0">

        {/* Bloque 1 — texto que ya tenías */}
        <div className="text-center space-y-4 py-8 sm:py-10 px-4 sm:px-6 
          rounded-t-2xl border border-matrix/30 bg-black">
          <h3 className="text-xl sm:text-3xl md:text-4xl font-serif 
            text-matrix text-glow-matrix leading-snug">
            {t.urgencyTitle}
          </h3>
          <p className="text-sm sm:text-xl text-gray-300 max-w-3xl 
            mx-auto leading-relaxed">
            {t.urgencyText}
          </p>
        </div>

        {/* Bloque 2 — nuevo: colliding + viñetas */}
        <div className="bg-gray-900/60 border-x border-matrix/30 px-6 py-8 space-y-6">

          <p className="text-sm sm:text-base text-gray-300 leading-relaxed">
            Quantum science, ancient wisdom, and consciousness research are converging on one conclusion —{' '}
            <span className="text-white font-semibold">
              but most people are still hypnotized by the noise.
            </span>
          </p>

          <div className="space-y-1">
            <p className="text-matrix font-mono text-xs uppercase tracking-widest mb-4">
              ◈ Here's why this moment matters:
            </p>

            {[
              {
                icon:<Sparkles size={20} className="text-matrix shrink-0 mt-0.5" />,
                text: 'Quantum science confirmed what mystics encoded centuries ago:',
                highlight: 'reality is information.'
              },
              {
                icon: <TrendingUp size={20} className="text-matrix shrink-0 mt-0.5" />,
                text: 'The fear-based systems that programmed your identity',
                highlight: 'are visibly collapsing.'
              },
              {
                icon: <Zap size={20} className="text-matrix shrink-0 mt-0.5" />,          
                text: 'The souls who remember the rules',
                highlight: 'aren´t just waking up — they are rewriting the field.'
              },
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3 
                p-3 rounded-lg border border-matrix/10 
                bg-black/30 hover:border-matrix/30 transition-all">
                <span className="text-matrix text-lg shrink-0 mt-0.5 
                  leading-none">
                  {item.icon}
                </span>
                <p className="text-sm sm:text-base text-gray-300 leading-snug">
                  {item.text}{' '}
                  <span className="text-matrix font-semibold">
                    {item.highlight}
                  </span>
                </p>
              </div>
            ))}
          </div>

        </div>

        {/* Bloque 3 — cierre: window won't stay open */}
        <div className="bg-black border border-t-0 border-matrix/30 
          rounded-b-2xl px-6 py-6 sm:py-8">
          <div className="flex items-start gap-4 max-w-3xl mx-auto">
            <span className="text-matrix text-2xl shrink-0 mt-1">⧖</span>
            <p className="text-sm sm:text-base text-gray-200 leading-relaxed italic">
              This window won't stay open forever. Every soul that remembers{' '}
              <span className="text-matrix font-semibold">
                creates a ripple.
              </span>{' '}
              — Every soul that delays closes the door a little more — on themselves first.
            </p>
          </div>
        </div>

      </section>

      {/* 6. Author — WARNING + Story + Imagine */}
      <section className="space-y-0">

        {/* WARNING banner */}
        <div className="bg-red-950/80 border border-red-500/60 rounded-t-2xl px-6 py-4 flex items-start gap-3">
          <span className="text-red-400 font-black text-lg shrink-0 mt-0.5">⚠</span>
          <div>
            <p className="text-red-400 font-black uppercase tracking-widest text-sm mb-1">
              Warning
            </p>
            <p className="text-red-200/90 text-sm sm:text-base leading-relaxed">
              What follows will not comfort your current beliefs. It will replace them with something more useful.
            </p>
          </div>
        </div>

        {/* Author card conectada al WARNING */}
        <div className="bg-gray-900/90 border border-gray-700/60 border-t-0 
          rounded-b-2xl px-6 py-8 space-y-6">

          {/* From / Location — estilo terminal */}
          <div className="font-mono text-xs sm:text-sm space-y-1 text-gray-400">
            <p>
              <span className="text-matrix">From:</span>{' '}
              <span className="text-white font-bold">Gabriel Beltrán</span>
            </p>
            <p>
              <span className="text-matrix">Location:</span>{' '}
              <span className="text-gray-300">Earth, Level 3 Density</span>
            </p>
          </div>

          {/* Historia — 3 párrafos separados con línea lateral */}
          <div className="border-l-2 border-matrix/40 pl-4 space-y-5 
            text-sm sm:text-base text-gray-300 leading-relaxed">

            {/* Párrafo 1 — El origen */}
            <p>
              I wasn't always the person writing this. For years I worked 
              inside the system — achieving, performing, repeating — completely 
              unaware that I was a Piece moving where the board told me to go.{' '}
              <span className="text-white font-semibold">
                Then one day a single question cracked everything open.
              </span>
            </p>

            {/* Párrafo 2 — El quiebre */}
            <p>
              <span className="text-white font-semibold">
                What if none of this is random?
              </span>{' '}
              <span className="text-matrix font-semibold">
                The moment I asked that — something shifted.
              </span>{' '}
              My life wasn't random. It was patterned. Scripted.{' '}
              <em className="text-gray-200">
                But not by fate. By code I'd never been shown.
              </em>{' '}
              And instead of panic, I felt something strange: clarity.{' '}
              <span className="text-white font-semibold">
                What if the game had rules? What if I could remember them?
              </span>
            </p>

            {/* Párrafo 3 — La investigación */}
            <p>
              What followed was years of deep research — ancient texts, 
              quantum physics, consciousness studies, and direct encounters 
              with the molecule that peels back the code: DMT.{' '}
              <span className="text-matrix font-semibold">
                What I found wasn't a belief system. It was an architecture.
              </span>{' '}
              A set of rules that reality was already running — with or 
              without my awareness.
            </p>

            {/* Párrafo 4 — El libro — separado visualmente */}
            <div className="border-t border-matrix/20 pt-4 space-y-1">
              <p className="text-xs font-mono text-matrix uppercase 
                tracking-widest">
                The result:
              </p>
              <p className="text-gray-200">
                <span className="text-white font-bold italic">
                  Are You Ready To Play?
                </span>{' '}
                That journey became the book — not a self-help book. 
                Not a spiritual manual.{' '}
                <span className="text-white font-semibold">
                  A field guide for souls who are done obeying fear 
                  and ready to hold the controller.
                </span>
              </p>
            </div>

          </div>

        </div>


          {/* Divider + Imagine this */}
          <div className="border-t border-gray-700/50 pt-6">

            <p className="text-matrix font-mono text-xs uppercase tracking-widest mb-4">
              ◈ Before I show you what's inside — let me ask you something:
            </p>

            <div className="space-y-3">
              {[
                {
                  icon: <Sunrise size={20} className="text-matrix shrink-0 mt-1" />,
                  text: <>What if you woke up tomorrow and the question  <span className="text-matrix font-semibold">"what's my purpose?" had simply... dissolved?</span></>
                },
                {
                  icon: <Compass size={20} className="text-matrix shrink-0 mt-1" />,
                  text: <>What if fear stopped being your default <span className="text-matrix font-semibold">and became information instead?</span></>
                },
                {
                  icon: <Waves size={20} className="text-matrix shrink-0 mt-1" />,
                  text: <><span className="text-matrix font-semibold">What if the synchronicities you've glimpsed became the normal texture of your days?</span> Synchronicities <span className="text-matrix font-semibold">multiply.</span></>
                },
                {
                  icon: <HeartPulse size={20} className="text-matrix shrink-0 mt-1" />,
                  text: <>What if you stopped asking "why is this happening to me?" — and started asking "what is this showing me?" <span className="text-matrix font-semibold">alive again.</span></>
                }
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  {item.icon}
                  <p className="text-gray-200 text-sm sm:text-base leading-snug">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>

          </div>
        
      </section>

      {/* 7. Oferta Digital — solo $27 */}
      <section id="offer-section" className="space-y-0">

        {/* Header de la card */}
        <div className="bg-matrix/10 border border-matrix/40 rounded-t-2xl 
          px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-matrix text-xs font-mono uppercase 
              tracking-widest">
              ⬇ Your Complete Awakening Package — Instant Access
            </span>
          </div>
          {/* Estrellas */}
          <div className="flex gap-1">
            {[1,2,3,4,5].map((s) => (
              <Star key={s} size={12} className="text-matrix" fill="currentColor" />
            ))}
          </div>
        </div>

        {/* Body principal */}
        <div className="bg-gray-900/80 border-x border-gray-700/50 px-6 py-8 
          space-y-6">

          {/* Imagen portada + precio */}
          <div className="flex flex-col sm:flex-row gap-6 items-center">

            {/* Imagen portada */}
            <div className="w-64 sm:w-72 shrink-0">
              <div className="aspect-[4/3] bg-gray-800 rounded-xl border 
                border-matrix/30 relative overflow-hidden flex items-center 
                justify-center">
                {/* Reemplazar con <img src="..." /> cuando tengas imagen real */}
                <img
                  src={IMG_MOCKUP}
                  alt="Are You Ready To Play - Book Mockup"
                  className="w-full h-full object-cover rounded-xl"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t 
                  from-black/60 via-transparent to-transparent" />
              </div>
            </div>

            {/* Precio y features */}
            <div className="flex-1 space-y-4">

              {/* Precio */}
              <div className="space-y-1">
                <div className="flex items-baseline gap-3">
                  <span className="text-5xl sm:text-6xl font-bold text-matrix 
                    text-glow-matrix">
                    $27
                  </span>
                  <span className="text-xl text-gray-500 line-through">$57</span>
                </div>
                <p className="text-matrix font-mono text-xs uppercase 
                  tracking-widest">
                  Instant Download
                </p>
              </div>

              {/* Features */}
              <ul className="space-y-2">
                {[
                  { icon: <Check size={14} />, text: 'access in 60 seconds' },
                  { icon: <Check size={14} />, text: 'Read on any device, anywhere' },
                  { icon: <Headphones size={14} />, text: 'Full audiobook included (1:49:47)' },
                ].map((feat, i) => (
                  <li key={i} className="flex items-center gap-3 
                    text-sm text-gray-300">
                    <span className="text-matrix shrink-0">{feat.icon}</span>
                    {feat.text}
                  </li>
                ))}
              </ul>

            </div>
          </div>

          {/* FREE BONUS #1 card */}
            <div className="rounded-xl border border-matrix/30 bg-black/50 p-4 
            sm:p-5 space-y-3">

            {/* Badge bonus */}
            <div className="flex items-center gap-2">
              <Headphones size={14} className="text-matrix" />
              <div className="flex flex-col gap-0.5">
                <span className="text-matrix font-mono text-xs uppercase tracking-widest font-bold">
                  🎁 FREE BONUS #1 — Included Today Only
                </span>
                <span className="text-gray-500 text-xs font-mono">
                  $39.97 Value — Yours Free
                </span>
              </div>
            </div>

            <div className="flex gap-4 items-start">

              {/* Imagen bonus */}
              <div className="w-32 sm:w-40 shrink-0">
                <div className="aspect-square bg-gray-800 rounded-lg border 
                  border-matrix/20 flex items-center justify-center 
                  text-gray-600 text-xs text-center">
                  {/* Reemplazar con <img src="..." /> */}
                    <img
                      src={IMG_PORTADADMT}
                      alt="DMT: The Spirit Molecule"
                      className="w-full h-full object-cover rounded-lg border 
                        border-matrix/20"
                        loading="lazy"
                    />
                </div>
              </div>

              {/* Texto bonus */}
              <div className="space-y-1 flex-1">
                <h4 className="text-white font-bold text-sm sm:text-base">
                  DMT: The Spirit Molecule
                </h4>
                <p className="text-gray-400 text-xs leading-relaxed">
                  The Science Behind the Veil 
                </p>
                <div className="flex items-center gap-2 text-xs text-gray-400">
                  <Headphones size={10} className="text-matrix" />
                  <span>Audiobook + Digital Edition</span>
                </div>
                <div className="inline-block bg-matrix/10 border 
                  border-matrix/30 text-matrix text-xs px-2 py-0.5 rounded-full 
                  font-mono">
                  ($39.97 Value)
                </div>

              </div>

            </div>

            {/* Audio player DMT */}
            <div className="rounded-lg bg-black/60 border border-matrix/20 p-3">
              
              <audio
                ref={dmtRef}
                src={AUDIO_DMT}
                preload="metadata"
                onTimeUpdate={() => setDmtTime(dmtRef.current?.currentTime || 0)}
                onLoadedMetadata={() => setDmtDuration(dmtRef.current?.duration || 0)}
                onEnded={() => setDmtPlaying(false)}
              />

              <div className="flex items-center gap-3">
                <button
                  onClick={() => {
                    if (!dmtRef.current) return;
                    if (dmtPlaying) {
                      dmtRef.current.pause();
                    } else {
                      dmtRef.current.play();
                    }
                    setDmtPlaying(!dmtPlaying);
                  }}
                  className="w-8 h-8 rounded-full bg-matrix/20 border border-matrix/40
                    flex items-center justify-center text-matrix 
                    hover:bg-matrix/30 transition-all shrink-0"
                >
                  {dmtPlaying 
                    ? <Pause size={12} /> 
                    : <Play size={12} className="ml-0.5" />
                  }
                </button>

                <div className="flex-1 space-y-1">
                  <p className="text-matrix text-xs font-mono">
                    DMT: The Spirit Molecule — Intro
                  </p>
                  <div
                    className="w-full h-1 bg-gray-700 rounded-full cursor-pointer"
                    onClick={(e) => {
                      if (!dmtRef.current || !dmtDuration) return;
                      const rect = e.currentTarget.getBoundingClientRect();
                      dmtRef.current.currentTime = 
                        ((e.clientX - rect.left) / rect.width) * dmtDuration;
                    }}
                  >
                    <div
                      className="h-1 bg-matrix rounded-full transition-all duration-100"
                      style={{ 
                        width: `${dmtDuration > 0 
                          ? (dmtTime / dmtDuration) * 100 
                          : 0}%` 
                      }}
                    />
                  </div>
                  <div className="flex justify-between text-gray-600 
                    text-xs font-mono">
                    <span>
                      {Math.floor(dmtTime / 60)}:
                      {Math.floor(dmtTime % 60).toString().padStart(2, '0')}
                    </span>
                    <span>
                      {Math.floor(dmtDuration / 60)}:
                      {Math.floor(dmtDuration % 60).toString().padStart(2, '0')}
                    </span>
                  </div>
                </div>
              </div>
            </div>

              {/* Read More / Less */}
              <button
                onClick={() => setDmtExpanded(!dmtExpanded)}
                className="flex items-center gap-2 text-matrix text-xs font-mono 
                  uppercase tracking-widest hover:text-matrix/70 transition-colors 
                  w-full justify-center py-1"
              >
                {dmtExpanded ? (
                  <>Read Less <ChevronUp size={14} /></>
                ) : (
                  <>Read More <ChevronDown size={14} /></>
                )}
              </button>

              {/* Contenido expandible */}
                {dmtExpanded && (
                  <div className="space-y-5 text-xs sm:text-sm text-gray-300 
                    leading-relaxed border-t border-matrix/20 pt-4">

                    {/* Intro hook */}
                    <div className="space-y-2">
                      <p className="text-gray-300 leading-relaxed">
                        <em>There's a molecule your brain produces naturally.</em>{' '}
                        <em>Scientists aren't sure why. Mystics always knew.</em>
                      </p>
                      <p className="text-gray-300 leading-relaxed">
                        <span className="text-white font-semibold">
                          DMT: The Spirit Molecule
                        </span>{' '}
                        is not another book about drugs — in fact it's not about drugs at all.
                      </p>
                      <p className="text-gray-300 leading-relaxed">
                        It's a decoded map of the territory your consciousness visits 
                        when the veil thins — in deep meditation, near-death experiences, 
                        and the moments between sleeping and waking.
                      </p>
                      <p className="text-gray-300 leading-relaxed">
                        Written in lyrical, thought-provoking prose that reads like a{' '}
                        <span className="text-matrix font-semibold">transmission</span>
                        {' '}— not a textbook — this book answers the questions mainstream 
                        science refuses to ask.
                      </p>
                    </div>

                    {/* Tabla de capítulos */}
                    <div className="space-y-2">
                      <p className="text-matrix font-mono text-xs uppercase tracking-widest">
                        ◈ Inside this bonus you'll discover:
                      </p>

                      <div className="space-y-2">
                  {[
                    {
                      chapter: 'The Brain\'s Secret',
                      detail: 'When DMT manifests, everything known dissolves. A bridge between being and the All.'
                    },
                    {
                      chapter: 'The Amazon Gateway',
                      detail: 'Why Ayahuasca — the ancient wisdom indigenous cultures preserve — is called "the vine of the soul."'
                    },
                    {
                      chapter: 'Quantum Mirrors',
                      detail: 'The precise overlap between mystical DMT visions and quantum physics.'
                    },
                    {
                      chapter: 'The Death Portal',
                      detail: 'Why the molecule spikes at death — and what that reveals about consciousness.'
                    },
                    {
                      chapter: 'Integration',
                      detail: 'How to use this knowledge without ever consuming a substance.'
                    },
                  ].map((row, i) => (
                    <div key={i} className="flex gap-3 p-3 rounded-lg bg-black/40 
                      border border-matrix/15 hover:border-matrix/30 transition-all">

                      {/* Columna izquierda — ancho fijo = palabra más larga "Integration" */}
                      <div className="w-[6.5rem] shrink-0 flex flex-col gap-0.5">
                        <span className="text-matrix font-mono text-xs font-bold">
                          0{i + 1}
                        </span>
                        <span className="text-white font-semibold text-xs leading-snug">
                          {row.chapter}
                        </span>
                      </div>

                      {/* Divisor vertical */}
                      <div className="w-px bg-matrix/20 shrink-0" />

                      {/* Columna derecha — ocupa el resto */}
                      <p className="text-gray-400 text-xs leading-snug flex-1 pl-2">
                        {row.detail}
                      </p>

                    </div>
                  ))}

                </div>
              </div>

              {/* Quote */}
              <div className="border-l-2 border-matrix/40 pl-4 py-1">
                <p className="text-white italic font-serif text-sm sm:text-base">
                  "This book is not about escaping reality — it's about 
                  remembering what reality truly is."
                </p>
              </div>

              {/* Details */}
              <div className="bg-black/40 rounded-lg border border-matrix/20 
                p-3 space-y-2 font-mono text-xs">
                <p className="text-matrix uppercase tracking-widest mb-2">
                  Details:
                </p>
                {[
                  { 
                    label: 'Format', 
                    value: 'Digital (92 pages) + Full Audiobook' 
                  },
                  { 
                    label: 'Genre', 
                    value: 'Consciousness · Science · Spirituality · Philosophy' 
                  },
                  { 
                    label: 'Delivered', 
                    value: 'Instantly at checkout' 
                  },
                ].map((d, i) => (
                  <div key={i} className="flex gap-2 items-start">
                    <span className="text-gray-500 shrink-0">{d.label}:</span>
                    <span className="text-gray-300">{d.value}</span>
                  </div>
                ))}
            </div>

          </div>
          )}
          </div>
        {/* FREE BONUS #2 — Mental Reset 7D */}
        <div className="rounded-xl border border-cyan-500/30 bg-black/50 
          p-4 sm:p-5 space-y-4">

          {/* Badge */}
          <div className="flex flex-col gap-0.5">
            <span className="text-cyan-400 font-mono text-xs uppercase 
              tracking-widest font-bold">
              🎁 FREE BONUS #2 — The Practical Companion
            </span>
            <span className="text-gray-500 text-xs font-mono">
              $27 Value — Yours Free
            </span>
          </div>

          {/* Imagen mockup + texto — igual que BONUS #1 */}
          <div className="flex gap-4 items-start">

            {/* Imagen mockup */}
            <div className="w-16 sm:w-20 shrink-0">
              {IMG_MENTAL_RESET ? (
                <img
                  src={IMG_MENTAL_RESET}
                  alt="Mental Reset 7D"
                  className="w-full h-full object-cover rounded-lg border 
                    border-cyan-500/20"
                  loading="lazy"
                />
              ) : (
                <div className="aspect-square bg-gray-800 rounded-lg border 
                  border-cyan-500/20 flex items-center justify-center 
                  text-gray-600 text-xs text-center p-1">
                  [img]
                </div>
              )}
            </div>

            {/* Texto */}
            <div className="space-y-1 flex-1">
              <h4 className="text-white font-bold text-sm sm:text-base">
                Mental Reset 7D
              </h4>
              <p className="text-gray-400 text-xs leading-relaxed">
                7-Day Mental Reboot: The Player's Practice Manual
              </p>
              <div className="flex items-center gap-2 text-xs text-gray-400">
                <BookOpen size={10} className="text-cyan-400" />
                <span>Digital PDF — English </span>
              </div>
              <div className="inline-block bg-cyan-500/10 border 
                border-cyan-500/30 text-cyan-400 text-xs px-2 py-0.5 
                rounded-full font-mono">
                ($27 Value)
              </div>
            </div>
          </div>

          {/* Versiones disponibles */}
          <div className="grid grid-cols-2 gap-2">
            <div className="flex items-center gap-2 p-2 rounded-lg 
              bg-gray-900/60 border border-gray-700/50">
              <span className="text-base">🌙</span>
              <div>
                <p className="text-white text-xs font-semibold">Reading Version</p>
                <p className="text-gray-500 text-[10px]">Dark design</p>
              </div>
            </div>
            <div className="flex items-center gap-2 p-2 rounded-lg 
              bg-white/5 border border-gray-600/50">
              <span className="text-base">🖨️</span>
              <div>
                <p className="text-white text-xs font-semibold">Printable Version</p>
                <p className="text-gray-500 text-[10px]">White background</p>
              </div>
            </div>
          </div>

          {/* Read More / Less */}
          <button
            onClick={() => setMentalExpanded(!mentalExpanded)}
            className="flex items-center gap-2 text-cyan-400 text-xs font-mono
              uppercase tracking-widest hover:text-cyan-300 transition-colors
              w-full justify-center py-1"
          >
            {mentalExpanded ? (
              <>Read Less <ChevronUp size={14} /></>
            ) : (
              <>Read More <ChevronDown size={14} /></>
            )}
          </button>

          {/* Contenido expandible */}
          {mentalExpanded && (
            <div className="space-y-5 text-xs sm:text-sm text-gray-300 
              leading-relaxed border-t border-cyan-500/20 pt-4">

              {/* Intro */}
              <div className="space-y-2">
                <p className="text-gray-300 leading-relaxed">
                  Reading awakens you.{' '}
                  <span className="text-white font-semibold">
                    Practice rewires you.
                  </span>
                </p>
                <p className="text-gray-300 leading-relaxed">
                  <span className="text-white font-semibold">Mental Reset 7D</span>{' '}
                  is the missing bridge between spiritual insight and daily reality.
                </p>
                <p className="text-gray-300 leading-relaxed">
                  While{' '}
                  <span className="text-white italic">Are You Ready To Play?</span>{' '}
                  gives you the map — this 7-day manual gives you{' '}
                  <span className="text-cyan-400 font-semibold">the moves.</span>
                </p>
                <p className="text-gray-300 leading-relaxed">
                  Each day is a short, powerful practice designed to dissolve 
                  one layer of programmed reality and install a new conscious 
                  response in its place.
                </p>
              </div>

              {/* Tabla 7 días */}
              {/* Quick Reference Table */}
              <div className="space-y-3">
                <p className="text-cyan-400 font-mono text-xs uppercase 
                  tracking-widest">
                  ◈ The Player's Quick Reference:
                </p>
                <p className="text-gray-400 text-xs italic">
                  Screenshot this. Keep it visible.
                </p>

                {/* Tabla */}
                <div className="rounded-lg overflow-hidden border 
                  border-cyan-500/20">

                  {/* Header */}
                  <div className="grid grid-cols-3 bg-cyan-950/40 
                    border-b border-cyan-500/20">
                    {['Day', 'Practice', 'Core Question'].map((h, i) => (
                      <div key={i} className="px-3 py-2">
                        <span className="text-cyan-400 font-mono text-xs 
                          uppercase tracking-wider font-bold">
                          {h}
                        </span>
                      </div>
                    ))}
                  </div>

                  {/* Rows */}
                  {[
                    { day: '1', practice: 'Observer Activation',     question: 'Am I reacting or choosing?' },
                    { day: '2', practice: 'Pattern Scanner',          question: 'Is this genuine or recorded?' },
                    { day: '3', practice: 'Fear Decode',              question: 'What is this pointing toward?' },
                    { day: '4', practice: 'Field Reset',              question: 'What is my body holding?' },
                    { day: '5', practice: 'Synchronicity Protocol',   question: 'What is the field signaling?' },
                    { day: '6', practice: 'Identity Upgrade',         question: 'Piece or Player — who is driving?' },
                    { day: '7', practice: 'Integration',              question: 'What am I ready to create?' },
                  ].map((row, i) => (
                    <div key={i} className={`grid grid-cols-3 border-b 
                      border-cyan-500/10 last:border-0 hover:bg-cyan-950/20 
                      transition-all ${i % 2 === 0 ? 'bg-black/20' : ''}`}>
                      
                      {/* Day */}
                      <div className="px-3 py-3 flex items-center">
                        <span className="text-cyan-400 font-mono font-bold 
                          text-sm">
                          {row.day}
                        </span>
                      </div>

                      {/* Practice */}
                      <div className="px-3 py-3 flex items-center 
                        border-x border-cyan-500/10">
                        <span className="text-white text-xs leading-snug 
                          font-semibold">
                          {row.practice}
                        </span>
                      </div>

                      {/* Core Question */}
                      <div className="px-3 py-3 flex items-center">
                        <span className="text-gray-400 text-xs leading-snug 
                          italic">
                          {row.question}
                        </span>
                      </div>

                    </div>
                  ))}
                </div>

                {/* The 3 Player Rules */}
                <div className="mt-4 bg-black/40 border border-cyan-500/20 
                  rounded-lg p-4 space-y-3">
                  <p className="text-cyan-400 font-mono text-xs uppercase 
                    tracking-widest font-bold">
                    The 3 Player Rules:
                  </p>
                  {[
                    { num: '1', rule: 'See before reacting' },
                    { num: '2', rule: 'Piece or Player — who is driving?' },
                    { num: '3', rule: 'What am I ready to create?' },
                  ].map((r, i) => (
                    <div key={i} className="flex items-center gap-3">
                      <span className="w-6 h-6 rounded-full bg-cyan-500/20 
                        border border-cyan-500/40 flex items-center 
                        justify-center text-cyan-400 font-mono font-bold 
                        text-xs shrink-0">
                        {r.num}
                      </span>
                      <span className="text-gray-300 text-sm">
                        {r.rule}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Daily Minimum */}
                <div className="bg-black/40 border border-cyan-500/20 
                  rounded-lg p-4 space-y-2">
                  <p className="text-cyan-400 font-mono text-xs uppercase 
                    tracking-widest font-bold">
                    The Player's Daily Minimum:
                  </p>
                  <div className="flex items-start gap-3">
                    <span className="text-cyan-400 text-xs font-mono 
                      shrink-0 mt-0.5">
                      Morning:
                    </span>
                    <span className="text-gray-300 text-xs leading-relaxed">
                      3 breath cycles + Observer position (5 min)
                    </span>
                  </div>
                </div>

              </div>
              

              {/* Quote */}
              <div className="border-l-2 border-cyan-400/40 pl-4 py-1">
                <p className="text-white italic font-serif text-sm sm:text-base">
                  "Available in English and Spanish — Premium design, delivered 
                  as an instant download."
                </p>
              </div>

              {/* Details */}
              <div className="bg-black/40 rounded-lg border border-cyan-500/20
                p-3 space-y-2 font-mono text-xs">
                <p className="text-cyan-400 uppercase tracking-widest mb-2">
                  Details:
                </p>
                {[
                  { label: 'Format',    value: 'Digital PDF' },
                  { label: 'Style',     value: 'Bestseller quality + practical manual' },
                  { label: 'Versions',  value: 'Reading (dark) + Print (white)' },
                  { label: 'Languages', value: 'English' },
                  { label: 'Delivered', value: 'Instantly at checkout' },
                ].map((d, i) => (
                  <div key={i} className="flex gap-2 items-start">
                    <span className="text-gray-500 shrink-0">{d.label}:</span>
                    <span className="text-gray-300">{d.value}</span>
                  </div>
                ))}
              </div>

            </div>
          )}

        </div>




        </div>

          {/* CTA button */}
          <div className="bg-black border-x border-b border-gray-700/50 
            rounded-b-2xl px-6 py-6">
            <Button
              variant="gold"
              className="w-full text-base sm:text-xl py-4 sm:py-6 
                shadow-[0_0_30px_rgba(255,215,0,0.3)]"
              onClick={() => {
                // 1. Facebook Pixel — AddToCart event
                // window.fbq('track', 'AddToCart', {
                //   content_name: 'Are You Ready To Play',
                //   content_type: 'product',
                //   value: 27.00,
                //   currency: 'USD'
                // });

                // 2. Redirigir a Shopify checkout
                // window.location.href = 'TU_URL_SHOPIFY_AQUI';
              }}
            >
              I AM READY TO REMEMBER
            </Button>
            <div className="flex items-center justify-center gap-2 mt-3 
              text-xs text-gray-500">
              <Lock size={10} />
              <span>Secure checkout — 7-Day Money Back Guarantee</span>
            </div>
          </div>
        </section>


          {/* 8. Pack Best Seller 
          <section className="relative z-20">
            <div className="absolute -inset-1 bg-gradient-to-r from-gold via-yellow-500 to-gold rounded-2xl blur opacity-30"></div>
            <div className="relative bg-black border-2 border-gold rounded-2xl p-5 sm:p-8 md:p-10 shadow-2xl">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gold text-black font-bold px-4 py-1.5 rounded-full text-xs sm:text-sm flex items-center gap-1 whitespace-nowrap">
                <Star size={12} fill="black" /> {t.packTitle} <Star size={12} fill="black" />
              </div>

              <div className="mt-6 text-center mb-6">
                <div className="flex justify-center items-baseline gap-3">
                  <span className="text-4xl sm:text-6xl font-bold text-gold text-glow-gold">
                    {t.packPriceNew}
                  </span>
                  <span className="text-xl text-gray-500 line-through">{t.packPriceOld}</span>
                </div>
              </div>

              <div className="space-y-3 mb-6">
                {t.packFeatures.map((feat, i) =>
                  <div key={i} className="flex items-start gap-3 p-3 rounded bg-gray-900/50 border border-gray-800">
                    <div className="mt-0.5 text-gold shrink-0"><Check size={16} /></div>
                    <span className="text-gray-200 text-xs sm:text-sm leading-relaxed">{feat}</span>
                  </div>
                )}
              </div>

              <Button variant="gold" className="w-full text-base sm:text-xl py-4 sm:py-6">
                {t.ctaGold}
              </Button>
            </div>
          </section>*/}


          {/* 9. What You Get — Core System + Resumen Oferta */}
          <section className="space-y-6 bg-gray-900/30 border border-matrix/20 
            rounded-2xl p-5 sm:p-8">

            {/* Headline */}
            <div className="text-center space-y-2">
              <p className="text-matrix font-mono text-xs uppercase tracking-widest">
                ◈ Here's Everything You Get When You Order
              </p>
              <h3 className="text-xl sm:text-3xl font-serif text-white">
                Are You Ready To Play?
              </h3>
            </div>

            {/* CORE SYSTEM */}
            <div className="space-y-3">

              {/* Header core */}
              <div className="flex items-center justify-between">
                <h4 className="text-lg sm:text-2xl font-serif text-gold font-bold">
                  The Core System
                </h4>
                <span className="text-gray-500 text-sm line-through">$57 Value</span>
              </div>

              {/* Descripción */}
              <p className="text-gray-400 text-xs sm:text-sm leading-relaxed 
                border-l-2 border-gold/40 pl-3 italic">
                Ready To Play — Who we are, who they are, what they hide...
              </p>

              {/* Includes */}
              <div className="flex gap-4 text-xs sm:text-sm">
                {[
                  { icon: <BookOpen size={14} />, text: 'Digital Ebook' },
                  { icon: <HeartPulse size={14} />, text: 'Audiobook version' },
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-2 text-gray-300">
                    <span className="text-gold">{item.icon}</span>
                    {item.text}
                  </div>
                ))}
              </div>

              {/* Módulos */}
              <div className="space-y-2 mt-2">
                {[
                  {
                    icon: <BookOpen size={16} />,
                    title: 'The Veil Revealed',
                    desc: 'Discover why you forgot who you are and how to remember.'
                  },
                  {
                    icon: <Lock size={16} />,
                    title: 'The Hidden Rules Of The System',
                    desc: 'Understand how fear, time, and identity keep you asleep.'
                  },
                  {
                    icon: <Zap size={16} />,
                    title: 'The Awakening Sequence',
                    desc: 'Step-by-step process to activate conscious play in daily life.'
                  },
                  {
                    icon: <Sparkles size={16} />,
                    title: 'The Infinite Game Blueprint',
                    desc: 'Learn how to create reality from love, not survival.'
                  },
                ].map((mod, i) => (
                  <div key={i} className="flex items-start gap-3 p-3 sm:p-4 
                    bg-black/40 rounded-lg border border-gray-800 
                    hover:border-gold/30 transition-all">
                    <div className="w-8 h-8 rounded-full bg-gold/10 flex items-center 
                      justify-center text-gold shrink-0">
                      {mod.icon}
                    </div>
                    <div>
                      <p className="text-white font-semibold text-xs sm:text-sm">
                        {mod.title}
                      </p>
                      <p className="text-gray-400 text-xs leading-snug mt-0.5">
                        {mod.desc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* This alone worth */}
              <div className="bg-gold/5 border border-gold/20 rounded-lg p-3 
                text-center">
                <p className="text-gold text-xs sm:text-sm font-serif italic">
                  This alone is worth{' '}
                  <span className="font-bold text-white">10x its actual price</span>
                  {' '}— because once you remember, nothing outside can control you again.
                </p>
              </div>

            </div>

            {/* Divider */}
            <div className="border-t border-gray-800" />

            {/* RESUMEN TOTAL — matemática del valor */}
            <div className="space-y-3">

              <p className="text-matrix font-mono text-xs uppercase tracking-widest 
                text-center">
                ◈ 6 Products — Price of 1
              </p>

              {/* Líneas de valor */}
              <div className="space-y-2">
                {[
                  {
                    label: 'Are You Ready To Play?',
                    sub: 'Digital Ebook + Audiobook',
                    value: '$57',
                    color: 'text-gold'
                  },
                  {
                    label: 'FREE BONUS #1 — DMT: The Spirit Molecule',
                    sub: 'Digital Ebook + Audiobook',
                    value: '$47',
                    color: 'text-matrix'
                  },
                  {
                    label: 'FREE BONUS #2 — Mental Reset 7D',
                    sub: 'Full Color PDF + Printable Version',
                    value: '$27',
                    color: 'text-cyan-400'
                  },
                ].map((item, i) => (
                  <div key={i} className="flex items-center justify-between 
                    gap-3 p-3 rounded-lg bg-black/40 border border-gray-800">
                    <div className="flex-1">
                      <p className={`text-xs sm:text-sm font-semibold ${item.color}`}>
                        {item.label}
                      </p>
                      <p className="text-gray-500 text-xs mt-0.5">{item.sub}</p>
                    </div>
                    <span className="text-gray-500 text-sm line-through shrink-0">
                      {item.value}
                    </span>
                  </div>
                ))}
              </div>

              {/* Total */}
              <div className="flex items-center justify-between p-3 rounded-lg 
                border border-gray-700 bg-gray-900/60">
                <span className="text-gray-400 text-xs sm:text-sm font-mono uppercase 
                  tracking-wider">
                  Total Value
                </span>
                <span className="text-white font-bold text-base sm:text-lg 
                  line-through text-gray-500">
                  $131
                </span>
              </div>

              {/* Precio hoy */}
              <div className="relative rounded-xl border-2 border-gold bg-black 
                p-4 sm:p-6 text-center space-y-2">

                {/* Badge urgencia */}
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 
                  bg-red-600 text-white text-xs px-4 py-0.5 rounded-full 
                  font-bold uppercase whitespace-nowrap animate-pulse">
                  ⚡ First Access Price
                </div>

                <p className="text-gray-400 text-xs font-mono uppercase 
                  tracking-widest pt-2">
                  Your investment today
                </p>

                <div className="flex items-baseline justify-center gap-3">
                  <span className="text-5xl sm:text-6xl font-bold text-gold 
                    text-glow-gold">
                    $27
                  </span>
                  <div className="flex flex-col items-start">
                    <span className="text-gray-500 text-sm line-through">$131</span>
                    <span className="text-red-400 text-xs font-bold">
                      79% OFF
                    </span>
                  </div>
                </div>

                <p className="text-gray-400 text-xs">
                  Returning to{' '}
                  <span className="text-white font-semibold">$57</span>
                  {' '}when this offer closes
                </p>

              </div>

            </div>

          </section>


          {/* 10. Testimonials */}
          <section className="space-y-8">

            {/* Header — igual estilo original */}
            <div className="text-center space-y-4">
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-serif 
                text-gold font-bold leading-snug">
                In just days of reading, readers report:
              </h3>

              {/* Pills */}
              <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
                {[
                  'Radical peace replacing anxiety',
                  'Electric sensations of remembrance',
                  'Synchronicities that confirm the code is responding',
                ].map((pill, i) => (
                  <span key={i} className="px-4 py-2 rounded-full border 
                    border-matrix/40 bg-matrix/5 text-gray-300 text-xs sm:text-sm
                    hover:border-matrix/70 transition-all">
                    {pill}
                  </span>
                ))}
              </div>
            </div>

            {/* Grid testimonials — 2 columnas mobile, 3 desktop */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {[
                {
                  text: "I felt like I was remembering something ancestral — something my mind always knew but couldn't access.",
                  author: 'E.M.',
                  tag: null
                },
                {
                  text: "Every paragraph dismantled a belief I didn't even know was programming. I finished it in one sitting.",
                  author: 'S.T.',
                  tag: null
                },
                {
                  text: "I stopped fighting life and started playing with it. That shift alone changed everything.",
                  author: 'L.R.',
                  tag: null
                },
                {
                  text: "I've read dozens of consciousness books. This one didn't add more information — it cleared the noise.",
                  author: 'M.K.',
                  tag: null
                },
                {
                  text: "The 7 codes aren't concepts. They're tools. I used one on day one and noticed the difference immediately.",
                  author: 'A.R.',
                  tag: null
                },
                {
                  text: "The Mental Reset 7D bonus alone was worth ten times what I paid. Day 3 broke a pattern I've carried for 11 years.",
                  author: 'C.V.',
                  tag: 'Mental Reset 7D'
                },
              ].map((test, i) => (
                <div key={i} className="bg-gray-900/50 p-4 sm:p-5 rounded-xl 
                  border border-gray-800 hover:border-matrix/30 
                  transition-all space-y-3 flex flex-col justify-between">

                  {/* Estrellas */}
                  <div className="flex text-gold gap-1">
                    {[1,2,3,4,5].map((s) => (
                      <Star key={s} size={12} fill="currentColor" />
                    ))}
                  </div>

                  {/* Quote */}
                  <p className="text-sm sm:text-base text-gray-300 italic 
                    leading-relaxed flex-1">
                    "{test.text}"
                  </p>

                  {/* Footer card */}
                  <div className="flex items-center justify-between pt-2 
                    border-t border-gray-800">
                    <span className="text-xs sm:text-sm font-bold text-white">
                      — {test.author}
                    </span>
                    {test.tag && (
                      <span className="text-xs text-cyan-400 font-mono 
                        bg-cyan-500/10 border border-cyan-500/20 
                        px-2 py-0.5 rounded-full">
                        {test.tag}
                      </span>
                    )}
                  </div>

                </div>
              ))}
            </div>

          </section>


          {/* 11. Guarantee */}
          <section className="bg-white/5 border border-white/10 rounded-2xl p-6 sm:p-12 text-center max-w-3xl mx-auto">
            <div className="inline-flex p-3 sm:p-4 rounded-full bg-gold/10 text-gold mb-4">
              <Shield size={36} />
            </div>
            <h3 className="text-xl sm:text-2xl md:text-3xl font-serif text-white mb-3">
              {t.guaranteeTitle}
            </h3>
            <p className="text-sm sm:text-base text-gray-400 mb-4 leading-relaxed">{t.guaranteeText}</p>
            <div className="text-xs text-gray-500 font-mono">support@ixanstudio.com</div>
          </section>



          {/* 12. Final CTA */}
          <section className="space-y-0 text-center">

            {/* Urgency block */}
            <div className="bg-red-950/60 border border-red-500/40 
              rounded-t-2xl p-5 sm:p-6 space-y-4">
              
              <div className="flex items-center justify-center gap-2">
                <span className="text-red-400 text-lg">⚠</span>
                <h4 className="text-red-400 font-bold uppercase tracking-widest 
                  text-sm sm:text-base">
                  First Access Price — Closing Soon
                </h4>
              </div>

              <p className="text-gray-300 text-xs sm:text-sm max-w-md mx-auto">
                This special launch price is limited. Once this first access 
                window closes, the price returns to{' '}
                <span className="text-white font-bold">$57.99.</span>
              </p>

              <div className="space-y-2 max-w-sm mx-auto text-left">
                {[
                  { icon: <Zap size={14} />,         text: 'Consciousness is accelerating — the next cycle won\'t wait.' },
                  { icon: <TrendingUp size={14} />,   text: 'The sooner you remember, the faster your reality shifts.' },
                  { icon: <Sparkles size={14} />,     text: 'Delay only feeds the program.' },
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-3 p-2 rounded-lg 
                    border border-red-500/20 bg-black/30">
                    <span className="text-red-400 shrink-0">{item.icon}</span>
                    <p className="text-gray-300 text-xs sm:text-sm">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Crossroads block */}
            <div className="bg-gray-900/80 border-x border-gray-700/50 
              p-6 sm:p-8 space-y-6">

              <h3 className="text-xl sm:text-3xl font-serif text-white">
                You stand at a crossroads.
              </h3>

              <div className="grid grid-cols-2 gap-3 max-w-sm mx-auto">
                <div className="p-3 sm:p-4 rounded-xl border border-red-500/30 
                  bg-red-950/20 space-y-1">
                  <p className="text-red-400 font-bold text-xs sm:text-sm 
                    uppercase tracking-wider">
                    Path 1
                  </p>
                  <p className="text-gray-400 text-xs leading-snug">
                    Keep playing blind, repeating the same loops.
                  </p>
                </div>
                <div className="p-3 sm:p-4 rounded-xl border border-matrix/40 
                  bg-matrix/5 space-y-1">
                  <p className="text-matrix font-bold text-xs sm:text-sm 
                    uppercase tracking-wider">
                    Path 2
                  </p>
                  <p className="text-gray-300 text-xs leading-snug">
                    Wake up and play consciously.
                  </p>
                </div>
              </div>

            </div>

            {/* Risk nothing + botón final */}
            <div className="bg-black border border-t-0 border-gray-700/50 
              rounded-b-2xl px-6 py-8 space-y-5">

              {/* You risk nothing */}
              <div className="space-y-1">
                <p className="text-white font-serif italic text-base sm:text-lg">
                  You risk nothing.
                </p>
                <p className="text-matrix font-semibold text-sm sm:text-base">
                  The only way to lose is by staying asleep.
                </p>
              </div>

              {/* Instrucción */}
              <p className="text-gray-400 text-xs sm:text-sm max-w-sm mx-auto 
                leading-relaxed">
                Click the button below to begin. In two minutes you'll receive 
                instant access to the book that has already changed countless souls.
              </p>

              {/* Frase emocional */}
              <p className="text-matrix font-serif italic text-sm sm:text-base">
                Tomorrow, you could see life with new eyes.
              </p>

              {/* Botón final */}
              <Button
                variant="gold"
                className="w-full text-base sm:text-xl py-4 sm:py-6
                  shadow-[0_0_40px_rgba(255,215,0,0.4)]"
                onClick={() => {
                  // window.fbq('track', 'AddToCart', {
                  //   content_name: 'Are You Ready To Play',
                  //   content_type: 'product',
                  //   value: 27.00,
                  //   currency: 'USD'
                  // });
                  // window.location.href = 'TU_URL_SHOPIFY_AQUI';
                }}
              >
                YES — I'M READY TO PLAY
              </Button>

              {/* Seguridad */}
              <div className="flex items-center justify-center gap-2 
                text-xs text-gray-500">
                <Lock size={10} />
                <span>Secure checkout — 7-Day Money Back Guarantee</span>
              </div>

            </div>

          </section>
          
          {/* 13. FAQ */}

          <section className="space-y-6">
            <h3 className="text-xl sm:text-2xl font-serif text-center text-white">
              F.A.Q.
            </h3>
            <div className="max-w-2xl mx-auto space-y-3">
              {t.faq.map((item, i) => (
                <div key={i} className="border border-matrix/20 rounded-xl overflow-hidden">
                  
                  {/* Pregunta */}
                  <button
                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                    className="w-full text-left px-4 py-4
                      bg-gray-950/95 backdrop-blur-sm
                      hover:bg-gray-900 transition-all
                      flex items-center justify-between gap-3"
                  >
                    <span className="text-white font-semibold text-sm sm:text-base 
                      leading-snug">
                      <span className="text-matrix mr-2">Q:</span>{item.q}
                    </span>
                    {openFaq === i
                      ? <ChevronUp size={16} className="text-matrix shrink-0" />
                      : <ChevronDown size={16} className="text-matrix shrink-0" />
                    }
                  </button>

                  {/* Respuesta */}
                  {openFaq === i && (
                    <div className="px-4 py-4
                      bg-black/95 backdrop-blur-sm
                      border-t border-matrix/10">
                      <p className="text-gray-200 text-sm sm:text-base leading-relaxed">
                        <span className="text-gray-500 font-bold mr-2">A:</span>
                        {item.a}
                      </p>
                    </div>
                  )}

                </div>
              ))}
            </div>
          </section>



          {/* 14. Footer */}

          {/* DISCLAIMER BLOCK — Footer */}
          <footer className="border-t border-gray-800 bg-black/95">

            {/* Links legales */}
            <div className="flex items-center justify-center gap-4 py-4 
              border-b border-gray-800/50">


              <button
                onClick={() => setShowTerms(true)}
                className="text-gray-500 hover:text-gray-300 text-xs 
                  font-mono underline underline-offset-2 transition-colors"
              >
                Terms of Service
              </button>
              <button
                onClick={() => setShowPrivacy(true)}
                className="text-gray-500 hover:text-gray-300 text-xs 
                  font-mono underline underline-offset-2 transition-colors"
              >
                Privacy Policy
              </button>
              <button
                onClick={() => setShowDisclaimer(true)}
                className="text-gray-500 hover:text-gray-300 text-xs 
                  font-mono underline underline-offset-2 transition-colors"
              >
                Disclaimer
              </button>
            </div>        

            {/* Disclaimer completo */}
            <div className="max-w-3xl mx-auto px-6 py-8 space-y-6">

              {/* 1. Meta Disclaimer */}
              <div className="space-y-1">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <span className="text-gray-500 font-semibold uppercase 
                    tracking-wider text-[10px]">
                    Meta / Facebook Disclaimer —{' '}
                  </span>
                  This site is not part of the Facebook website or Facebook Inc. 
                  Additionally, this site is NOT endorsed by Facebook in any way. 
                  FACEBOOK is a trademark of FACEBOOK, Inc.
                </p>
              </div>

              {/* Divisor */}
              <div className="border-t border-gray-800/50" />

              {/* 2. Content Disclaimer — DMT */}
              <div className="space-y-1">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <span className="text-gray-500 font-semibold uppercase 
                    tracking-wider text-[10px]">
                    Content & Legal Notice —{' '}
                  </span>
                  The book "DMT: The Spirit Molecule" and the contents of this 
                  site are intended purely for educational, philosophical, and 
                  scientific purposes related to the biology of consciousness. 
                  The information presented here does not constitute medical or 
                  psychological advice. We do not promote, encourage, or 
                  facilitate the use of illegal or controlled substances. 
                  The use of the terms "Matrix" and "Player" is employed as a 
                  philosophical metaphor for human potential development and does 
                  not guarantee specific results in the user's perception or health.
                </p>
              </div>

              {/* Divisor */}
              <div className="border-t border-gray-800/50" />

              {/* 3. Results Disclaimer */}
              <div className="space-y-1">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <span className="text-gray-500 font-semibold uppercase 
                    tracking-wider text-[10px]">
                    Results Disclaimer —{' '}
                  </span>
                  Testimonials and examples presented on this site represent 
                  individual experiences and do not guarantee that you will 
                  achieve the same results. Success with the "Ready to Play" 
                  program and understanding of its advanced concepts requires 
                  dedication, study, and personal application. Your level of 
                  success will depend on the time you devote to the program 
                  and your individual abilities.
                </p>
              </div>

              {/* Divisor */}
              <div className="border-t border-gray-800/50" />

              {/* Copyright + contacto */}
              <div className="flex flex-col sm:flex-row items-center 
                justify-between gap-2 text-[10px] text-gray-600 font-mono">
                <span>© 2025 Ixan Studio. All rights reserved.</span>
                <a 
                  href="mailto:support.ixanstudio@gmail.com"
                  className="hover:text-gray-400 transition-colors"
                >
                  support.ixanstudio@gmail.com
                </a>
              </div>

            </div>

          </footer>

        </div>
        
        {/* Modal reutilizable */}
        {(showTerms || showPrivacy || showDisclaimer) && (
          <div 
            className="fixed inset-0 z-50 flex items-center justify-center 
              bg-black/80 backdrop-blur-sm p-4"
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                setShowTerms(false);
                setShowPrivacy(false);
                setShowDisclaimer(false);
              }
            }}
          >
            <div className="bg-gray-950 border border-matrix/20 rounded-2xl 
              w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col">

              {/* Header modal */}
              <div className="flex items-center justify-between px-6 py-4 
                border-b border-gray-800 shrink-0">
                <h3 className="text-white font-bold text-base sm:text-lg">
                  {showTerms    && 'Terms of Service'}
                  {showPrivacy  && 'Privacy Policy'}
                  {showDisclaimer && 'Disclaimer'}
                </h3>
                <button
                  onClick={() => {
                    setShowTerms(false);
                    setShowPrivacy(false);
                    setShowDisclaimer(false);
                  }}
                  className="text-gray-500 hover:text-white transition-colors 
                    w-8 h-8 flex items-center justify-center rounded-full 
                    hover:bg-gray-800"
                >
                  ✕
                </button>
              </div>

              {/* Contenido scrolleable */}
              <div className="overflow-y-auto px-6 py-6 space-y-6 
                text-gray-300 text-sm leading-relaxed">

                {/* TERMS OF SERVICE */}
                {showTerms && (
                  <div className="space-y-5">
                    <p className="text-gray-500 text-xs font-mono">
                      Last updated: March 10, 2026
                    </p>
                    <p className="text-gray-300">
                      Welcome to Ready to Play / Ixan Studio. By accessing our 
                      website and using our services, you agree to comply with 
                      the following terms and conditions.
                    </p>
                    {[
                      {
                        title: '1. Nature of the Content',
                        content: 'The content provided through this site, including the book "DMT: The Spirit Molecule", is intended exclusively for informational, educational, and philosophical entertainment purposes. It does not constitute medical advice and should not replace consultation with a health professional. Under no circumstances should this content be interpreted as a recommendation or promotion of illegal activities or the use of controlled substances.'
                      },
                      {
                        title: '2. Intellectual Property',
                        content: 'All material on this site (texts, AI-generated images, logos, and design concepts) is the property of Ixan Studio or used under license. A limited, personal, non-transferable license is granted to download one copy of the digital book for personal, non-commercial use. Redistribution, sale, or modification of the content without prior written consent is strictly prohibited.'
                      },
                      {
                        title: '3. Disclaimer of Warranties',
                        content: 'Ixan Studio does not guarantee that results obtained from studying these materials will be identical for all users. You agree that use of the information is at your own risk. We are not responsible for any loss or damage resulting from the interpretation of the "Matrix" or "Player" metaphors in real-life contexts.'
                      },
                      {
                        title: '4. Use of the "Ready to Play" Brand',
                        content: 'The Ready to Play system is a proprietary methodological framework. The use of the term "Matrix" is employed in its general linguistic and philosophical sense (as a structure or network) and is not intended to infringe on the trademark rights of third parties.'
                      },
                      {
                        title: '5. Modifications to the Service',
                        content: 'We reserve the right to modify, suspend, or discontinue any aspect of the service or book offering at any time without prior notice.'
                      },
                      {
                        title: '6. Jurisdiction and Applicable Law',
                        content: 'These terms are governed by the laws of the United States. Any dispute related to these terms will be resolved in the competent courts of said jurisdiction.'
                      },
                    ].map((section, i) => (
                      <div key={i} className="space-y-2">
                        <h4 className="text-white font-semibold text-sm">
                          {section.title}
                        </h4>
                        <p className="text-gray-400 text-sm leading-relaxed">
                          {section.content}
                        </p>
                      </div>
                    ))}
                  </div>
                )}

                {/* PRIVACY POLICY */}
                {showPrivacy && (
                  <div className="space-y-5">
                    <p className="text-gray-500 text-xs font-mono">
                      Last updated: February 25, 2026
                    </p>
                    <p className="text-gray-300">
                      At Ready to Play / Ixan Studio, we value your privacy and 
                      are committed to protecting your personal data.
                    </p>
                    {[
                      {
                        title: '1. Information We Collect',
                        content: 'We collect information you voluntarily provide through our registration forms, which may include: full name, email address, and contact information related to your interest in the Ready to Play program.'
                      },
                      {
                        title: '2. Use of Information',
                        content: 'Collected data is used exclusively to: send access to the digital book and related materials, provide information about program updates and exclusive offers, and improve the user experience on our website through statistical analysis.'
                      },
                      {
                        title: '3. Legal Basis for Processing',
                        content: 'In accordance with the General Data Protection Regulation (GDPR) and applicable laws, we process your data under the explicit consent granted when completing our forms and under the legitimate interest of providing you with the requested services.'
                      },
                      {
                        title: '4. Data Protection & Third Parties',
                        content: 'We do not sell, rent, or transfer your personal data to third parties. Your data is protected through digital security protocols (SSL). Note: We use third-party tools such as Meta Pixel for marketing and analytics purposes, which operate under their own privacy policies.'
                      },
                      {
                        title: '5. Your Rights',
                        content: 'You have the right at any time to: access, rectify, or delete your personal data, withdraw your consent to receive commercial communications, and request limitation or objection to data processing. To exercise these rights, contact us at: support.ixanstudio@gmail.com'
                      },
                      {
                        title: '6. Cookies',
                        content: 'This site uses cookies to personalize your experience and analyze advertising traffic. By continuing to browse, you accept the use of cookies in accordance with our policy.'
                      },
                    ].map((section, i) => (
                      <div key={i} className="space-y-2">
                        <h4 className="text-white font-semibold text-sm">
                          {section.title}
                        </h4>
                        <p className="text-gray-400 text-sm leading-relaxed">
                          {section.content}
                        </p>
                      </div>
                    ))}
                  </div>
                )}

                {/* DISCLAIMER */}
                {showDisclaimer && (
                  <div className="space-y-5">
                    {[
                      {
                        title: 'Meta / Facebook Disclaimer',
                        content: 'This site is not part of the Facebook website or Facebook Inc. Additionally, this site is NOT endorsed by Facebook in any way. FACEBOOK is a trademark of FACEBOOK, Inc.'
                      },
                      {
                        title: 'Content & Legal Notice',
                        content: 'The book "DMT: The Spirit Molecule" and the contents of this site are intended purely for educational, philosophical, and scientific purposes related to the biology of consciousness. The information presented does not constitute medical or psychological advice. We do not promote, encourage, or facilitate the use of illegal or controlled substances. The use of the terms "Matrix" and "Player" is employed as a philosophical metaphor for human potential development and does not guarantee specific results in the user\'s perception or health.'
                      },
                      {
                        title: 'Results Disclaimer',
                        content: 'Testimonials and examples presented on this site represent individual experiences and do not guarantee that you will achieve the same results. Success with the "Ready to Play" program requires dedication, study, and personal application. Your level of success will depend on the time you devote to the program and your individual abilities.'
                      },
                    ].map((section, i) => (
                      <div key={i} className="space-y-2 pb-4 border-b 
                        border-gray-800 last:border-0">
                        <h4 className="text-matrix font-semibold text-sm 
                          uppercase tracking-wider">
                          {section.title}
                        </h4>
                        <p className="text-gray-400 text-sm leading-relaxed">
                          {section.content}
                        </p>
                      </div>
                    ))}
                  </div>
                )}

              </div>

              {/* Footer modal */}
              <div className="px-6 py-4 border-t border-gray-800 shrink-0">
                <button
                  onClick={() => {
                    setShowTerms(false);
                    setShowPrivacy(false);
                    setShowDisclaimer(false);
                  }}
                  className="w-full py-2 rounded-lg border border-gray-700 
                    text-gray-400 hover:text-white hover:border-gray-500 
                    transition-all text-sm font-mono"
                >
                  Close
                </button>
              </div>

            </div>
          </div>
        )}

      </>


      );




}
